<template>
  <nav class="cloud-sidebar" :class="{ 'cloud-sidebar--open': mobileOpen }">
    <button class="cloud-sidebar__mobile-toggle d-lg-none" @click="mobileOpen = !mobileOpen">
      <i :class="mobileOpen ? 'fe-x' : 'fe-menu'"></i>
    </button>

    <div class="cloud-sidebar__nav">
      <span class="cloud-sidebar__section-label">{{ $t('cloud.sidebar.categories') }}</span>

      <div v-for="item in categoryItems" :key="item.route"
           :class="['cloud-sidebar__item', { 'cloud-sidebar__item--active': currUrl === item.route }]"
           @click="navigateTo(item.route, item.params)">
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>

      <span class="cloud-sidebar__section-label">{{ $t('cloud.sidebar.profile') }}</span>

      <div v-for="item in profileItems" :key="item.route"
           :class="['cloud-sidebar__item', { 'cloud-sidebar__item--active': isProfileActive(item) }]"
           @click="navigateTo(item.route, item.params)">
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>

    <b-modal :visible="showModal" id="preview-listing" hide-header hide-footer size="xl" @hidden="closeModal">
      <cloud-listing-preview v-if="showModal" :listing-id="listingId"></cloud-listing-preview>
    </b-modal>
  </nav>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {CloudListingPreview: () => import(/* webpackPrefetch: true */ "@components/cloud/preview/CloudListingPreview")},
  data() {
    return {
      mobileOpen: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.currentUser,
      showModal: state => state.cloud._showPreviewModal,
      listingId: state => state.cloud._selectedListing
    }),
    currUrl() {
      return this.$route.name
    },
    urlUser() {
      return this.$route.params.userId;
    },
    categoryItems() {
      return [
        {route: 'cloud', icon: 'fe-home', label: this.$t('cloud.sidebar.home')},
        {route: 'cloud-diet-plans', icon: 'fe-file-text', label: this.$t('cloud.sidebar.plans')},
        {route: 'cloud-recipes', icon: 'fe-book-open', label: this.$t('cloud.sidebar.recipes')},
        {route: 'cloud-foods', icon: 'fe-package', label: this.$t('foods')},
      ]
    },
    profileItems() {
      return [
        {
          route: 'cloud-user-listings',
          icon: 'fe-list',
          label: this.$t('cloud.sidebar.listings'),
          params: {userId: this.user.id}
        },
        {
          route: 'cloud-user',
          icon: 'fe-user',
          label: this.$t('cloud.sidebar.myProfile'),
          params: {userId: this.user.id}
        },
      ]
    }
  },
  watch: {
    '$route'() {
      this.mobileOpen = false;
    }
  },
  methods: {
    navigateTo(name, params) {
      this.$router.push({name, params});
    },
    closeModal() {
      this.$store.dispatch('cloud/setShowPreviewModal', false);
    },
    isProfileActive(item) {
      return this.currUrl === item.route && this.urlUser === this.user.id;
    }
  }
}
</script>

<style lang="scss" scoped>
.cloud-sidebar {
  flex: 0 0 195px;
  background: #fff;
  border-right: 1px solid $color_border;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - #{$topbar-height});
  position: sticky;
  top: $topbar-height;
  align-self: flex-start;
  overflow-y: auto;

  @media (max-width: 991px) {
    flex: none;
    width: 100%;
    min-height: 0;
    position: relative;
    top: 0;
    padding: 0;
    border-right: none;
    border-bottom: 1px solid $color_border;
  }
}

.cloud-sidebar__mobile-toggle {
  display: none;
  width: 100%;
  padding: 0.65rem 1rem;
  background: none;
  border: none;
  text-align: left;
  font-size: 1.2rem;
  color: $color_text;
  cursor: pointer;

  @media (max-width: 991px) {
    display: block;
  }
}

.cloud-sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 0 0.5rem;

  @media (max-width: 991px) {
    display: none;
    padding: 0.5rem 0.75rem 0.75rem;

    .cloud-sidebar--open & {
      display: flex;
    }
  }
}

.cloud-sidebar__section-label {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #b0b7c3;
  padding: 0.85rem 0.6rem 0.25rem;

  &:first-child {
    padding-top: 0.25rem;
  }
}

.cloud-sidebar__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.45rem 0.6rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: #4b5563;
  cursor: pointer;
  border-radius: 6px;
  border-left: 2px solid transparent;
  transition: all 0.15s ease;

  i {
    font-size: 0.9rem;
    width: 16px;
    text-align: center;
    flex-shrink: 0;
    opacity: 0.7;
  }

  &:hover {
    background: rgba($color_primary, 0.05);
    color: $color_primary;

    i { opacity: 1; }
  }

  &--active {
    border-left-color: $color_primary;
    color: $color_primary;
    background: rgba($color_primary, 0.05);
    font-weight: 600;

    i { opacity: 1; }
  }
}
</style>
